import { cx } from "@/utils/classnames";
import { ReactNode } from "react";

export const Girdle = ({
  children,
  className,
  disableMinWidth,
}: {
  children: ReactNode;
  className?: string;
  disableMinWidth?: boolean;
}) => (
  <div
    // mx-auto, not m-auto: this wrapper only girdles width. Inside a
    // flex-column main section (e.g. the trace explorer pages), vertical auto
    // margins would center short content, flashing a large blank gap above
    // the page header until loading content grows to fill the viewport.
    className={cx("mx-auto", className)}
    style={{ minWidth: disableMinWidth ? undefined : "768px" }}
  >
    {children}
  </div>
);

export const NarrowGirdle = ({ children }: { children: ReactNode }) => (
  <div className="max-w-screen-sm m-auto">{children}</div>
);
